<template>
  <table class="expert-tool-history__prescription-comparison">
    <tbody>
      <history-comparison-row
        class="expert-tool-history__prescription-comparison-previous"
        :label="$ucfirst($t('current'))"
        :date="previousPrescriptionDate"
        :prescription="previousPrescription"
      ></history-comparison-row>
      <history-comparison-row
        class="expert-tool-history__prescription-comparison-selected"
        :label="$ucfirst($t('alerts.date'))"
        :date="selectedPrescriptionDate"
        :prescription="selectedPrescription"
      ></history-comparison-row>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from 'vuex';
import HistoryComparisonRow from './HistoryComparisonRow';

/**
 * Component HistoryPrescriptionComparison.vue
 *
 * @module HistoryPrescriptionComparison
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [deprecated] app/src/APP_DASHBOARD/templates/views/ExpertTool/History/HistoryPrescriptionComparison.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'HistoryComparison',
  components: { HistoryComparisonRow },
  data() {
    return {
      rows: [
        {
          class: 'expert-tool-history__comparison-previous',
          getterName: 'previousPrescription',
        },
        {
          class: 'expert-tool-history__comparison-selected',
          getterName: 'selectedPrescription',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      hasPreviousPrescription: 'expertTool/hasPreviousPrescription',
      previousPrescription: 'expertTool/previousPrescription',
      selectedPrescription: 'expertTool/selectedPrescription',
      selectedPrescriptionDate: 'expertTool/selectedPrescriptionDate',
      previousPrescriptionDate: 'expertTool/previousPrescriptionDate',
    }),
  },
};
</script>

<style lang="scss">
.expert-tool-history__prescription-comparison {
  border-radius: 16px;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 32px;
  width: 100%;
}

.expert-tool-history__comparison-row-label {
  width: 220px;
}

.expert-tool-history__prescription-comparison-previous {
  .expert-tool-history__comparison-row-label {
    background-color: #069dd6;
    color: #fff;
    font-weight: 600;
  }
}

.expert-tool-history__prescription-comparison-previous td {
  border-bottom: 1px solid #069dd6;
  border-top: 1px solid #069dd6;
}

.expert-tool-history__prescription-comparison-previous td:first-child {
  border-top-left-radius: 16px;
  border-left: 1px solid #069dd6;
}

.expert-tool-history__prescription-comparison-previous td:last-child {
  border-top-right-radius: 16px;
  border-right: 1px solid #069dd6;
}

.expert-tool-history__prescription-comparison-selected {
  .expert-tool-history__comparison-row-label {
    background-color: #f6f6f8;
    font-weight: 600;
    border-right: 1px solid #d6dbe4;
  }
}

.expert-tool-history__prescription-comparison-selected td {
  border-bottom: 1px solid #d6dbe4;
}

.expert-tool-history__prescription-comparison-selected td:first-child {
  border-bottom-left-radius: 16px;
  border-left: 1px solid #d6dbe4;
}

.expert-tool-history__prescription-comparison-selected td:last-child {
  border-bottom-right-radius: 16px;
  border-right: 1px solid #d6dbe4;
}
</style>
